<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 style="font-size:14px;font-weight:bold;margin-bottom:15px;">Required options</h5>
      </div>
    </div>
    <div v-if="colourOptions && trimOptions" class="row">
      <div class="col-12 mb-2">
        <div class="custom-multiselect mb-2">
          <label for="trim">Colour</label>
          <VueMultiselect
            v-if="colourOptions"
            id="colour"
            v-model="vueColour"
            placeholder=""
            label="description"
            track-by="description"
            option="value"
            selectLabel=""
            deselectLabel=""
            :multiple="false"
            :options="colourOptions"
            @update:model-value="setColor"
          >
<!--            <template slot="singleLabel" slot-scope="trimOptions">
              <div class="select-option">
                <div class="select-option-label">{{trimOptions.option.title}}</div>
                <div class="select-option-value">{{trimOptions.option.price}}</div>
              </div>
            </template>
            <template slot="option" slot-scope="trimOptions">
              <div class="select-option">
                <div class="select-option-label">{{trimOptions.option.title}}</div>
                <div class="select-option-value">{{trimOptions.option.price}}</div>
              </div>
            </template>-->
          </VueMultiselect>
        </div>
      </div>

      <div class="col-12">
        <div class="custom-multiselect mb-2">
          <label for="trim">Trim</label>
          <VueMultiselect
            v-if="trimOptions"
            id="trim"
            v-model="vueTrim"
            placeholder=""
            label="description"
            track-by="description"
            option="value"
            selectLabel=""
            deselectLabel=""
            :multiple="false"
            :options="trimOptions"
            @update:model-value="setTrim"
          >
<!--            <template slot="singleLabel" slot-scope="trimOptions">
              <div class="select-option">
                <div class="select-option-label">{{trimOptions.option.title}}</div>
                <div class="select-option-value">{{trimOptions.option.price}}</div>
              </div>
            </template>
            <template slot="option" slot-scope="trimOptions">
              <div class="select-option">
                <div class="select-option-label">{{trimOptions.option.title}}</div>
                <div class="select-option-value">{{trimOptions.option.price}}</div>
              </div>
            </template>-->
          </VueMultiselect>
        </div>
      </div>
    </div>
    <div v-else class="text-center p-4">
      <loading-icon></loading-icon>
    </div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import {EventBus} from '@/event-bus.js';
import LoadingIcon from "@/components/loading-icon";

export default {
  name: "configure-vehicle",
  components: { VueMultiselect, LoadingIcon, EventBus },
  props: [
    'shortlist',
    'quote',
    'colourOptions',
    'trimOptions',
  ],

  data: () => {
    return {
      vueColour: null,
      vueTrim: null,
    }
  },

  watch: {
    colourOptions() {
      if (this.colourOptions.length) {
        this.vueColour = collect(this.colourOptions).where('selected', true).first();
        if (this.vueColour) {
          this.setColor({value: this.vueColour.value});
        }
      }
    },
    trimOptions() {
      if (this.trimOptions.length) {
        this.vueTrim = collect(this.trimOptions).where('selected', true).first();
        if (this.vueTrim) {
          this.setTrim({value: this.vueTrim.value});
        }
      }
    },
  },

  methods: {
    setTrim(event) {
      EventBus.$emit('trimSelected', { value: event.value, quoteId: this.quote.quoteID });
    },

    setColor(event) {
      EventBus.$emit('colorSelected', { value: event.value, quoteId: this.quote.quoteID });
    },

    /*changeFactoryOption(event) {
      if (event?.value) {
        this.toggleFactoryOption(this.shortlist.quote.quoteGUID, event.value, 'added')
      }
    },

    // Update a factory option on the quote.
    toggleFactoryOption(quoteGuid, factoryOptionID, operation) {
      EventBus.$emit('loadingTitle', 'Updating Quote');
      EventBus.$emit('loading', true);

      this.$http.put('/api/toggle-factory-option', {
        quoteGuid: quoteGuid,
        derivativeId: this.shortlist.derivativeID,
        factoryOptionId: factoryOptionID,
        operation: operation // added, deleted
      })
        .then(response => {
          EventBus.$emit('loading', false);

          this.$nextTick(() => {
            this.quoteFactoryOptions = response.data.data.quoteFactoryOptions;
            this.shortlist.quote = response.data.data.quote;
            this.derivativeFactoryOptions = response.data.data.derivativeFactoryOptions;

            this.colourOptions = response.data.data.colourOptions;
            this.vueColour = collect(response.data.data.colourOptions).where('selected', true).first();

            this.trimOptions = response.data.data.trimOptions;
            this.vueTrim = collect(response.data.data.trimOptions).where('selected', true).first();

          });

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: response.data.message
          });

        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.error.message
          });

          this.error = err.message.toString();
          if (response.redirect) {
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          }
        });
    },*/
  }
}
</script>

<style scoped lang="scss">
  .select-option {
    display: flex;
    margin-bottom: 5px;

    &-label {
      flex-grow: 1;
    }

    &-value {
      font-weight: bold;
      padding-right: 30px;
      font-size: 20px;
      margin-top: -10px;
    }
  }
</style>
